// extracted by mini-css-extract-plugin
export var addOverflowY = "di46s";
export var appContainer = "QdrUx";
export var appContainerClippedOverflow = "jIdm1";
export var appContainerHiddenOverflow = "ljSCk";
export var bleedThrough = "dPXfr";
export var hideOverflowY = "DSIdO";
export var main = "NzIuH";
export var mainContainer = "Flvp1";
export var monarchAwareBackground = "UU8iG";